import { render } from "./AuthenticationCard.vue?vue&type=template&id=0abc33a5"
const script = {}

import exportComponent from "/Users/saleem/Sites/WIMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__